/**
 * How often a screen re-checks the server.
 *
 * One number, in one place, because the alternative is fifteen of them
 * scattered across pages and a load question nobody can answer without
 * grepping. Changing the polling policy should be one edit.
 *
 * A minute is a deliberate trade: every open screen costs one small request a
 * minute rather than six or more, which is what "do not flood the server"
 * actually means when twenty staff are signed in at once. It costs freshness
 * on the screens that watch for work arriving - see the note below.
 *
 * Not everything that polls uses this. The kiosk's sync indicator reads local
 * SQLite through the Android bridge and never touches the server, so slowing
 * it would buy nothing and make a working device look stalled.
 *
 * ## Where a minute has a cost
 *
 * Two screens exist to notice work arriving, and both now notice it up to a
 * minute later:
 *
 *  - the kitchen display, where a chef may wait a minute to see an order the
 *    till has already rung up, and
 *  - online orders, where an aggregator ticket sits unseen for the same.
 *
 * Both are low-volume - one or two tablets per property, not one per member
 * of staff - so neither was ever the source of the load. If service suffers,
 * they are the two to give their own faster interval back.
 */
export const POLL_MS = 60_000;
